module.exports = __webpack_public_path__ + "static/img/hone-gsjs.c335299.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/hone-gsjs.png
// module id = pNg9
// module chunks = 0